import React, { Component, PropTypes } from 'react'
import { Button, Grid, Message } from 'semantic-ui-react'

import FooterComponent from '../../gallery/components/FooterComponent'

import '../../../node_modules/semantic-ui-css/components/button.css'
import '../../../node_modules/semantic-ui-css/components/grid.css'
import '../../../node_modules/semantic-ui-css/components/message.css'

export default class ErrorPageComponent extends Component {

  static propTypes = {
    handleRouteToLogin: PropTypes.func.isRequired,
  }

  render () {
    const { handleRouteToLogin } = this.props
    return (
      <div>
        <Grid centered stackable columns={2} className='push'>
          <Grid.Column>
            <Message
              error
              className='messageWidth90'
              compact
            >
              <Message.Header>
                Access Forbidden
              </Message.Header>
              <p>
                Sorry, you cannot access this page without being signed in. Please click the button below to be taken to login.
              </p>
              <Grid centered columns={2}>
                <Grid.Column textAlign='center' className=' marginTop2'>
                  <Button
                    className='rounded-button'
                    color='yellow'
                    onClick={handleRouteToLogin}
                  >
                  Log In
                </Button>
                </Grid.Column>
              </Grid>
            </Message>
          </Grid.Column>
        </Grid> {/* End Login Grid */}
        <FooterComponent />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/gallery/components/ErrorPageComponent.js